<div class="dialog-wrapper h-100 w-100" [@.disabled]="isAnimationDisabled$ | async">
	<ng-container [ngSwitch]="currentView$ | async">
		<div *ngSwitchCase="potentialSavingsViews.LOADING" class="d-flex h-100 w-100">
			<app-default-loading-state class="dialog-wrapper__container"></app-default-loading-state>
		</div>
		<div *ngSwitchCase="potentialSavingsViews.TOTAL_SAVING" class="d-flex h-100 w-100">
			<div
				class="dialog-wrapper__container h-100 position-relative"
				[@breakdownExpand]="(isExtended$ | async) ? 'expanded' : 'collapsed'"
				[style.width.px]="DEFAULT_PS_MODAL_WIDTH"
				[style.z-index]="1"
			>
				<app-total-savings
					[isExtended]="isExtended$ | async"
					[isZestyDomain]="isZestyDomain"
					[isEDP]="isEDP$ | async"
					[isMonthlyState]="isMonthlyState$ | async"
					[data]="potentialSavings$ | async"
					(toggleIsMonthlyState)="toggleIsMonthlyState($event)"
					(shrinkModal)="shrinkDialog()"
					(expandPsDialog)="expandDialog()"
					(toggleEDP)="onToggleEDP($event)"
					(applyButtonClicked)="onApplyButtonClicked($event)"
					(refreshPsData)="refreshData()"
					(close)="dialogRef.close()"
				></app-total-savings>
			</div>
			<div class="dialog-wrapper__container h-100" *ngIf="isExtended$ | async" [@slideInOut] [@fadeInOut]>
				<app-savings-breakdown
					[isAllocationsAndLinuxTabsAllowed]="isAllocationsAndLinuxTabsAllowed$ | async"
					[isZestyEmployee]="isZestyEmployee"
					[isZestyDomain]="isZestyDomain"
					[isMonthlyState]="isMonthlyState$ | async"
					[potentialSaveData]="potentialSavings$ | async"
					[isEDP]="isEDP$ | async"
					(openAwsCostExplorer)="openAwsCostExplorer()"
					(replaceModalView)="replaceModalView($event)"
				></app-savings-breakdown>
			</div>
		</div>
		<div *ngSwitchCase="potentialSavingsViews.LINUX_UNCOVERED" class="dialog-wrapper__container w-100 h-100">
			<app-linux-uncovered
				[data]="linuxSteadyState$ | async"
				(openTotalSavingPanel)="openTotalSavingPanel()"
			></app-linux-uncovered>
		</div>
		<div *ngSwitchCase="potentialSavingsViews.SAVINGS_GRAPH" class="dialog-wrapper__container w-100 h-100">
			<app-savings-graph
				[data]="(potentialSavings$ | async)?.savingsGraphPoints"
				(openTotalSavingPanel)="openTotalSavingPanel()"
				(close)="dialogRef.close()"
			></app-savings-graph>
		</div>
		<div *ngSwitchCase="potentialSavingsViews.DEEPDIVE_RENEWAL" class="dialog-wrapper__container h-100 w-100">
			<app-renewal-over-time
				[data]="(potentialSavings$ | async)?.graphPoints"
				[dailySavings]="(potentialSavings$ | async)?.oneDaySavings"
				[startDate]="(potentialSavings$ | async)?.updatedAt"
				(close)="openTotalSavingPanel()"
			></app-renewal-over-time>
		</div>
		<div *ngSwitchCase="potentialSavingsViews.RI_SP_TABLE" class="dialog-wrapper__container h-100 w-100">
			<app-commitment-list [productLabel]="productLabel" (close)="openTotalSavingPanel()"></app-commitment-list>
		</div>
		<div *ngSwitchCase="potentialSavingsViews.SP_ALLOCATION" class="dialog-wrapper__container h-100 w-100">
			<app-sp-allocation
				[data]="potentialSavings$ | async"
				(openTotalSavingPanel)="openTotalSavingPanel()"
			></app-sp-allocation>
		</div>
		<div *ngSwitchCase="potentialSavingsViews.SWITCH_EDP_MODE" class="dialog-wrapper__container h-100 w-100">
			<app-switch-to-edp-mode (close)="onSwitchToEdpClose($event)"></app-switch-to-edp-mode>
		</div>
	</ng-container>
</div>

<ng-template #loading>
	<div class="position-relative spinner-wrapper overflow-hidden h-100 w-100">
		<app-spinner></app-spinner>
	</div>
</ng-template>
